import type { FaireProductEntity } from "../../entity_types/product";

export const p_n9arwrzn6h: FaireProductEntity = {
  token: "p_n9arwrzn6h",
  type: "product",
  name: "tag Pine Tree Led Candle Small",
  brandToken: "b_82ce35da",
  brandName: "tag",
  imageUrl:
    "https://cdn.faire.com/fastly/56d7f2e1a1096875617d9f29f2b6dd41120ee18d32403bac0f99fd3a6aeefc46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0880905032391e6249cec535b2b67d2872d9b09e23f7bdf4767494a8fd8e6da1.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "add a touch of winter magic to your home with this small green pine tree led candle.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:27.018Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
